@if (item) {
<app-expand-menu [item]="item" (actionClicked)="onActionClick($event)" />
}
